import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationProtocolAssayCreateRequest,
    ConfigurationProtocolAssayResponse
} from '@/modules/configurationModule/detail/local-assays/protocols/services/configuration-protocol-assay/configuration-protocol-assay.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationProtocolAssayService {
    async create(laboratoryId: number, request: ConfigurationProtocolAssayCreateRequest): Promise<ConfigurationProtocolAssayResponse> {
        const response = await axios.post<ConfigurationProtocolAssayResponse>(`/configuration/laboratories/${laboratoryId}/protocolAssays`, request)
        return response.data
    }

    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationProtocolAssayResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationProtocolAssayResponse>>(`/configuration/laboratories/${laboratoryId}/protocolAssays`, { ...filterModel }, { params })
        return response.data
    }

    async get(protocolAssayId: number, laboratoryId: number): Promise<ConfigurationProtocolAssayResponse> {
        const response = await axios.get<ConfigurationProtocolAssayResponse>(`/configuration/laboratories/${laboratoryId}/protocolAssays/${protocolAssayId}`)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/protocolAssays/batch`, { data: request })
        return response.data
    }
}

export const configurationProtocolAssayService = new ConfigurationProtocolAssayService()
